<template>
    <b-modal id="bv-modal-add-group-task" size="lg" title="Grupos/Bases" scrollable centered no-stacking>
        <div class="container">
            <div class="card-body">
                <form>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="name">Nome *</label>
                                <input id="name" v-model="form.name" type="text" required class="form-control" />
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="members">Membros</label>
                                <div class="multiselect-container">
                                    <input
                                        type="text"
                                        v-model="searchTerm"
                                        placeholder="Pesquisar usuários..."
                                        class="form-control mb-2"
                                    >
                                    <div class="checkbox-list" style="max-height: 200px; overflow-y: auto; border: 1px solid #ced4da; border-radius: 4px; padding: 10px;">
                                        <div v-for="user in filteredUsers" :key="user._id" class="form-check">
                                            <input
                                                class="form-check-input"
                                                type="checkbox"
                                                :id="`task-member-${user._id}`"
                                                :value="user._id"
                                                v-model="form.members"
                                            >
                                            <label class="form-check-label" :for="`task-member-${user._id}`">
                                                {{ user.name }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <template #modal-footer>
            <div class="d-flex flex-row-reverse justify-content-between" style="width: 100%;">
                <button type="submit" @click.prevent="submitForm" class="btn btn-primary" :disabled="loading">
                    <span v-if="loading">
                        <i class="fas fa-spinner fa-pulse"></i> Aguarde...
                    </span>
                    <span v-else>
                        <i class="fas fa-save"></i> Salvar
                    </span>
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import Swal from 'sweetalert2';

import { taskManagerAxios } from '../connections/taskApiConnection';

export default {
    name: "GroupsTaskModal",
    data() {
        return {
            loading: false,
            allUsers: [],
            dataEdit: {},
            searchTerm: '',
            form: {
                name: '',
                members: [],
                tag: 'co'
            }
        }
    },
    computed: {
        isEditing() {
            return this.dataEdit && this.dataEdit._id;
        },
        filteredUsers() {
            if (!this.searchTerm) return this.allUsers;
            return this.allUsers.filter(user =>
                user.name.toLowerCase().includes(this.searchTerm.toLowerCase())
            );
        }
    },
    watch: {
        dataEdit: {
            handler(newData) {
                if (newData && Object.keys(newData).length > 0) {
                    this.loadFormData(newData);
                }
            },
            immediate: true
        }
    },
    created() {
        this.fetchUsers();
    },
    methods: {
        async fetchUsers() {
            try {
                const { data } = await taskManagerAxios.get('/users/origin/co');
                this.allUsers = data;
            } catch (error) {
                console.error(error);
            }
        },
        openModal(data) {
            this.resetForm();
            if (data) {
                this.dataEdit = data;
                this.loadFormData(data);
            }
            this.$bvModal.show('bv-modal-add-group-task');
        },
        closeModal(data = null) {
            this.loading = false;
            this.resetForm();
            if (data) this.$emit("updateGroupTable", data);
            this.$bvModal.hide('bv-modal-add-group-task');
        },
        loadFormData(data) {
            this.form._id = data._id;
            this.form.name = data.name;
            this.form.tag = data.tag;
            if (data.members && Array.isArray(data.members)) {
                this.form.members = data.members.map(member =>
                    typeof member === 'object' ? member._id : member
                );
            }
        },
        resetForm() {
            this.form = { name: '', members: [], tag: 'co' };
            this.searchTerm = '';
            this.dataEdit = {};
        },
        validateForm() {
            if (!this.form.name) {
                Swal.fire({ type: "error", text: "Campo 'Nome' é obrigatório!" });
                return false;
            }
            if (this.form.members.length < 1) {
                Swal.fire({ type: "error", text: "Campo 'Membros' é obrigatório!" });
                return false;
            }
            return true;
        },
        async submitForm() {
            if (!this.validateForm()) return;
            this.loading = true;
            const formData = { ...this.form };
            try {
                if (this.form._id) {
                    const { data } = await taskManagerAxios.put(`/groups/${this.form._id}`, formData);
                    Swal.fire({ type: "success", text: "Base (Grupo) atualizado com sucesso." });
                    this.closeModal(data);
                } else {
                    const { data } = await taskManagerAxios.post('/groups', formData);
                    Swal.fire({ type: "success", text: "Base (Grupo) salvo com sucesso." });
                    this.closeModal(data);
                }
            } catch (error) {
                console.error(error);
                Swal.fire({ type: "error", text: "Falha ao salvar base (grupo)! Valide todos os campos e tente novamente." });
                this.loading = false;
            }
        },
    },
}
</script>
